import {AktionTypeEnum} from "../../../models/api/insight/AktionTypeEnum";
import type {Insight} from "../../../models/api/insight/Insight";
import {InsightTypeEnum} from "../../../models/api/insight/InsightTypeEnum";
import {KategorieEnum} from "../../../models/api/insight/KategorieEnum";
import {LizenzEnum} from "../../../models/api/insight/LizenzEnum";

const insights: Array<Insight> = [
    {
        id: "20260709-material",
        datum: "09.07.2026",
        kategorie: KategorieEnum.DESKTOP,
        type: InsightTypeEnum.VERBESSERTES_FEATURE,
        title: "Update: Materialsystem mit gemeinsamer Sollmenge",
        lizenz: [LizenzEnum.PRO, LizenzEnum.KURSE, LizenzEnum.FREE],
        content: [
            "Ab sofort werden Sollmengen im Materialsystem gemeinsam je Lagerort, Modell und Größe verwaltet. Das sorgt"
            + " für mehr Übersicht, eine passendere Berechnung des Fehlbestands und entspricht besser der Praxis. Ein"
            + " kleiner Anzeigefehler, der direkt nach dem Update aufgetreten ist, wurde bereits behoben.",
        ],
        aktions: [
            {
                type: AktionTypeEnum.BLOG,
                text: "Details im Blog",
                url: "https://info.hiorg-server.de/2026/07/update-materialsystem-jetzt-mit-gemeinsamer-sollmenge/",
            },
        ],
    },
];

export {
    insights,
};
